import {
  getFeeLimitMin,
  isFeeCountModifiable,
  updateSelectedFee,
  useFeesAnalytics,
  getFeeKeyById,
  useAnalytics,
} from '@greystar/lib';
import Counter from '../Controls/Counter/Counter';
import FeeLine from '../FeeLine/FeeLine';
import FeeLineItemProps from './FeeLineItem.props';

export default function FeeLineItem(props: FeeLineItemProps) {
  const showCounter = props.fee && isFeeCountModifiable(props.fee) && !props.isSummaryStep;
  const { mergeAnalyticsData } = useFeesAnalytics();
  const analytics = useAnalytics();

  const updateData = (feeId: string | undefined | number, updateType: string) => {
    if (feeId !== undefined) {
      mergeAnalyticsData({
        overrides: {
          event: 'unit_rent_calc_update',
          action_type: 'update',
          updated_item: getFeeKeyById(feeId),
          click_text: updateType,
          click_type: 'internal',
        },
        onComplete: (data) => {
          analytics.trackEvent('unit_rent_calc_update', data);
        },
      });
    }
  };

  return (
    <>
      {showCounter && props.fee ? (
        <Counter
          {...props}
          fee={props.fee}
          handlePlus={(updateFeeProps) => {
            if (updateFeeProps.selectedFee) {
              updateSelectedFee(
                props.dispatch,
                props.feeState
              )({
                ...updateFeeProps,
                selectedFee: updateFeeProps.selectedFee,
              });
            }

            updateData(updateFeeProps.selectedFee?.id, 'increment');
          }}
          handleMinus={(updateFeeProps) => {
            if (updateFeeProps.selectedFee) {
              updateSelectedFee(
                props.dispatch,
                props.feeState
              )({
                ...updateFeeProps,
                selectedFee: updateFeeProps.selectedFee,
              });
            }

            updateData(updateFeeProps.selectedFee?.id, 'decrement');
          }}
          maxThreshold={parseInt(props.fee.limit)}
          minThreshold={getFeeLimitMin(props.fee)}
          defaultValue={props.fee.activeCount}
        />
      ) : (
        <FeeLine {...props} />
      )}
    </>
  );
}
